import { InjectionToken, Signal } from '@angular/core';
import { AccountDto, AccountMediaKind, AccountUpdatePayload } from '../models/winery-account';

export interface WineryAccountApi {
  user: Signal<AccountDto | null>;
  isHydrated: Signal<boolean>;
  refreshAccount(): Promise<AccountDto | null>;
  updateAccount(payload: AccountUpdatePayload): Promise<AccountDto>;
  updateShowWhenVerified(showWhenVerified: boolean): Promise<AccountDto>;
  uploadAccountMedia(kind: AccountMediaKind, file: File): Promise<AccountDto>;
  removeAccountMedia(kind: AccountMediaKind): Promise<AccountDto>;
}

export const WINERY_ACCOUNT_API = new InjectionToken<WineryAccountApi>('WINERY_ACCOUNT_API');
